module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.5a87cce8.ttf";